module.exports = __webpack_public_path__ + "static/img/b4.7b7d638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b4.png
// module id = dnxV
// module chunks = 1